import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { Tag } from "features/shared/types/tag";
import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";

// the tag to add is going to be with no 'id' field as it is auto generated
const addOneTag =
    (tag: Tag): AppThunk =>
    async (dispatch) => {
        const db = firebase.firestore();
        const newTagRef = db.collection("tags").doc(tag.key);

        await newTagRef.set(tag);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Added one tag with key ${tag.key}`,
                },
            })
        );

        return;
    };

export default addOneTag;
